import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import client from "../../lib/api";
import AdminLayout from "./AdminLayout";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textarea";
import { Label } from "../../components/ui/label";

const FIELDS = [
  ["heroHeadline", "Homepage Hero Headline", "textarea"],
  ["heroSupporting", "Homepage Supporting Text", "textarea"],
  ["tagline", "Tagline", "text"],
  ["footerText", "Footer Text", "text"],
  ["trustEmail", "Contact Email (displayed)", "text"],
];

export default function ContentEditor() {
  const [content, setContent] = useState({});
  useEffect(() => { client.get("/admin/content/site").then(({ data }) => setContent(data || {})).catch(() => {}); }, []);
  const save = async () => {
    try { await client.put("/admin/content/site", content); toast.success("Website content updated."); }
    catch { toast.error("Could not save."); }
  };
  return (
    <AdminLayout title="Website Content">
      <p className="mb-6 max-w-2xl text-sm text-ink-muted">Update the main text shown on the public website. Registration particulars are protected and are not editable here to prevent accidental changes.</p>
      <div className="max-w-2xl space-y-5 rounded-md border border-gold/20 bg-white p-7">
        {FIELDS.map(([key, label, type]) => (
          <div key={key}>
            <Label>{label}</Label>
            {type === "textarea"
              ? <Textarea className="mt-1.5" rows={3} value={content[key] || ""} onChange={(e) => setContent({ ...content, [key]: e.target.value })} data-testid={`content-${key}`} />
              : <Input className="mt-1.5" value={content[key] || ""} onChange={(e) => setContent({ ...content, [key]: e.target.value })} data-testid={`content-${key}`} />}
          </div>
        ))}
        <button onClick={save} data-testid="content-save" className="bg-maroon px-6 py-3 text-xs uppercase tracking-wide text-ivory hover:bg-maroon-dark">Save Changes</button>
      </div>
    </AdminLayout>
  );
}
